import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import RendererPage from './render-pages/RenderPage';
import { ROUTES } from './utils/routes';
import history from "./utils/history";
import { Helmet } from "react-helmet";

/**
 * Should the App redirect to the home page
 *
 * @param {string} modelUrl     - Path of the current model
 * @return {boolean}
 */

 const canRedirectHome = (pathname, history) => {
  if (!pathname || window.location.search !== '') {
      return false;
  }
  if(window.location.search !=='' && history.action === 'PUSH'){
      return true;
  }
  if(history.action === 'POP'){
      return true;
  }
};

function App() {
    
  const redirect = () => {
      const locationPathName = window.location.pathname;
      const home = "/consulta-soat";
      if (canRedirectHome(locationPathName, history)) {
          return history.push(home);
      }
  };

  return (
      <Switch>
          <Redirect exact path="/" to="/consulta-soat" />
          
          {ROUTES.map( (route, i) => {
              return (
                  <Route exact path={route} key={`item-router-${i}`}>
                      <div className="App consultaSoatPage">
                            <Helmet>
                                <title>Consultar SOAT Virtual | Verifica tu SOAT por placa - 2023</title>
                                <meta name="description" content="Ahora puedes consultar tu SOAT, con tu número de placa y DNI. Consulta y descarga tu SOAT  de forma rápida y sencilla ¡Ingresa Aquí!" />
                                <meta property="og:title" content="Consultar SOAT Virtual | Verifica tu SOAT por placa - 2023"/>
                                <meta property="og:description" content="Ahora puedes consultar tu SOAT, con tu número de placa y DNI. Consulta y descarga tu SOAT  de forma rápida y sencilla ¡Ingresa Aquí!"/>
                                <link rel="canonical" href="https://www.rimac.com/consulta-soat" />
                            </Helmet>
                          {redirect()}
                          {RendererPage(route)}
                      </div>
                  </Route>
              )
          })}
      </Switch>
  )
}


export default App;
